import React from "react"
import { useOrder } from "context/order"
import { useLocale } from "context/locale"

import StyledOrderNav from "./styles"

const OrderNav = () => {
  const { step } = useOrder()
  const { t } = useLocale()

  const steps = [
    { id: 1, name: t("Shipping method") },
    { id: 2, name: t("Your data") },
    { id: 3, name: t("Number of cartons") },
    { id: 4, name: t("Pick-up date") },
    { id: 5, name: t("Your donation choice") },
  ]

  return (
    <StyledOrderNav>
      <div className="steps-desktop">
        {steps.map(({ id, name }) => (
          <span
            key={id}
            className={step === id ? "current" : null}
            dangerouslySetInnerHTML={{ __html: name.replace("|", " <br />") }}
          />
        ))}
      </div>
      <div className="steps-mobile">
        <div className="steps-mobile__progress">
          {steps.map(({ id }) => (
            <span key={id} className={step === id ? "current" : null} />
          ))}
        </div>
        <div className="steps-mobile__desc">
          <div className="box box-name">
            {steps.map(({ id, name }) => (
              <span key={id} className={step === id ? "current" : null}>
                {name.replace("|", "")}
              </span>
            ))}
          </div>
          <div className="box">
            <span>
              {t("Step")} {step}/5
            </span>
          </div>
        </div>
      </div>
    </StyledOrderNav>
  )
}

export default OrderNav
